import { useEffect, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { isEmpty } from 'lodash';
import { useMutation, useQuery } from 'urql';

import { Property } from '../../../Graphql/Generated/graphql';
import { LIKE_PROPERTY, UNLIKE_PROPERTY } from '../../../Graphql/mutations';
import { IS_PROPERTY_LIKED } from '../../../Graphql/queries';
import ImageLoader from '../Generics/Image';
import './DisplayListings.css';

interface IPropsListingCard {
  place: Property;
}

const ListingCard = (props: IPropsListingCard) => {
  const navigate = useNavigate();
  const [liked, setLiked] = useState(false);

  const likePropertyMutationVariables: any = useMemo(() => {
    return {
      propertyId: props.place.id,
      userId: !isEmpty(sessionStorage.getItem('userId'))
        ? sessionStorage.getItem('userId')
        : '',
    };
  }, [liked]);

  const [, likePlace] = useMutation(LIKE_PROPERTY);
  const [, unlikePlace] = useMutation(UNLIKE_PROPERTY);

  const queryVariables: any = useMemo(() => {
    return {
      propertyId: props.place.id,
      userId: sessionStorage.getItem('userId'),
    };
  }, [props.place.id]);

  const [result] = useQuery({
    query: IS_PROPERTY_LIKED,
    variables: queryVariables,
    pause: isEmpty(sessionStorage.getItem('userId')),
  });

  useEffect(() => {
    if (!result.error && result.data) {
      setLiked(result.data.isPropertyLiked);
    }
  }, [result.error, result.data]);

  const handleLikedChange = () => {
    if (liked) {
      unlikePlace(likePropertyMutationVariables);
    } else {
      likePlace(likePropertyMutationVariables);
    }
    setLiked(!liked);
  };

  const urlSafeTitle = encodeURIComponent(props.place.title || '');

  return (
    <div className='propertyCard'>
      {isEmpty(sessionStorage.getItem('userId')) ? null : (
        <div className='heartContainer' onClick={() => handleLikedChange()}>
          {liked ? (
            <FavoriteIcon sx={{ fontSize: '1.7em', color: '#DB5769' }} />
          ) : (
            <FavoriteBorderIcon sx={{ fontSize: '1.7em', color: 'gray' }} />
          )}
        </div>
      )}
      <Link to={`/property/${urlSafeTitle}`} state={props.place}>
        <div className='propertyGradient'>
          {props.place && props.place.images && props.place.images.length > 0 ? (
            <ImageLoader
              width={505}
              height={254}
              filename={props.place.images[0]}
              className='propertyImgListing'
              place={props.place}
              loading='lazy'
            />
          ) : (
            <div className='propertyNoImg'>No Image Available</div>
          )}
        </div>
      </Link>
      <div className='propertyInfo'>
        <div className='bedBath'>
          {/* Checks for bad data */}
          {props.place.rooms && props.place.rooms <= 0
            ? null
            : `${props.place.rooms} bedrooms • `}
          {props.place.baths && props.place.baths <= 0 ? null : `${props.place.baths} bath`}
        </div>
        <div className='propertyLocation'>
          {!isEmpty(props.place.title) ? props.place.title : props.place.addressLine1}
        </div>
        {/* SQFT is being removed for now because the majority of the data doesn't support it */}
        {/* <div className='propertySqft'> {props.place.sqft} sqft</div> */}
        <div className='propertyPrice'>
          {props.place.baseRent ? `$${props.place.baseRent} / 30 days` : 'Inquire for price'}
        </div>
      </div>
    </div>
  );
};

export default ListingCard;
